var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.001,
    height: 10.001,
    viewBox: "0 0 10.001 10.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-close",
    d: "M9.706-2.706a1,1,0,0,1,0,1.414A.991.991,0,0,1,9-1a1,1,0,0,1-.707-.293L5-4.584,1.707-1.294A.991.991,0,0,1,1-1a.991.991,0,0,1-.707-.294,1,1,0,0,1,0-1.414L3.587-6,.293-9.294a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L5-7.412l3.294-3.294a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414L6.414-6,9.706-2.706Z",
    transform: "translate(0 11.001)",
    fill: "#5e5e5e",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.aac6e504e499c6e84a201a8721709a2f.svg";
export { ForwardRef as ReactComponent };